var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrmenuLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 305.67 76.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7ae5f2;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.05,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.05,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.05,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.05,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.27,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.27,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.27,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.88,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.48,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 18.27,
    width: 2.61,
    height: 2.61
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.09,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 18.27,
    width: 2.61,
    height: 2.61
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.7,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.92,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 18.27,
    width: 2.61,
    height: 2.61
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.53,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 18.27,
    width: 2.61,
    height: 2.61
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.14,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.75,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.36,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.97,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.58,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.19,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.8,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 23.48,
    width: 2.61,
    height: 2.61
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 31.31,
    width: 2.61,
    height: 2.61
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 49.58,
    width: 2.61,
    height: 2.61
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 20.88,
    width: 2.61,
    height: 2.61
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 28.7,
    width: 2.61,
    height: 2.61
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 39.14,
    width: 2.61,
    height: 2.61
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 46.97,
    width: 2.61,
    height: 2.61
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 26.09,
    width: 2.61,
    height: 2.61
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 33.92,
    width: 2.61,
    height: 2.61
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 36.53,
    width: 2.61,
    height: 2.61
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 41.75,
    width: 2.61,
    height: 2.61
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 44.36,
    width: 2.61,
    height: 2.61
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 52.19,
    width: 2.61,
    height: 2.61
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 54.8,
    width: 2.61,
    height: 2.61
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2.61,
    height: 2.61
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.05,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.41,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.02,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.45,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 2.61,
    width: 2.61,
    height: 2.61
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 13.05,
    width: 2.61,
    height: 2.61
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.06,
    y: 15.66,
    width: 2.61,
    height: 2.61
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.63,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.23,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 5.22,
    width: 2.61,
    height: 2.61
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 7.83,
    width: 2.61,
    height: 2.61
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.84,
    y: 10.44,
    width: 2.61,
    height: 2.61
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.61,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.05,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.05,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 57.41,
    width: 2.61,
    height: 2.61
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 60.02,
    width: 2.61,
    height: 2.61
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 70.45,
    width: 2.61,
    height: 2.61
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.66,
    y: 73.06,
    width: 2.61,
    height: 2.61
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.22,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.83,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 62.63,
    width: 2.61,
    height: 2.61
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 65.23,
    width: 2.61,
    height: 2.61
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.44,
    y: 67.84,
    width: 2.61,
    height: 2.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.34,256.19q0-6-1.56-8.4t-6-2.44a13.86,13.86,0,0,0-10.41,4.88q-4.54,4.89-4.55,8.8v34.79H218V256.19q0-6-1.56-8.4c-1.05-1.63-3.26-2.44-6.65-2.44s-6.6,1.56-9.63,4.69-4.67,6-4.93,8.69v35.09h-6.84V245h6.84V256a19.26,19.26,0,0,1,5.77-7.82,14,14,0,0,1,9.38-3.62,29.58,29.58,0,0,1,8.26.93,7.55,7.55,0,0,1,4.35,2.88,10.56,10.56,0,0,1,1.56,3.43,21.67,21.67,0,0,1,.29,4.1,19.28,19.28,0,0,1,5.67-7.77,13.2,13.2,0,0,1,8.8-3.57,28.75,28.75,0,0,1,7.52.79,14.44,14.44,0,0,1,4.25,1.75,6,6,0,0,1,2.15,2.84,11.54,11.54,0,0,1,.84,3c.06.78.09,1.89.09,3.32v30.59a7.2,7.2,0,0,0,1.13,4.35,3.41,3.41,0,0,0,2.29,1.62l1.08.19h3v.78h-6c-2.68,0-4.71-.58-6.11-1.76a5.17,5.17,0,0,1-2.2-3.52l-.1-1.66Z",
    transform: "translate(-102.74 -218.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.29,270q0,12.12,4.25,17.79a13.32,13.32,0,0,0,11.19,5.67,48.29,48.29,0,0,0,17.39-2.93l.3.68a48.56,48.56,0,0,1-17.64,3q-9.82,0-16-5.86t-6.16-18.08q0-12.22,6.45-19a21.72,21.72,0,0,1,16.42-6.75A19.78,19.78,0,0,1,301,249.35q5.47,4.8,5.47,14.17v1H271.58A48.56,48.56,0,0,0,271.29,270Zm24.92-20.13a11,11,0,0,0-9.09-4.49q-5.58,0-9.92,4.88t-5.52,13.49h28.14Q299.73,254.33,296.21,249.84Z",
    transform: "translate(-102.74 -218.05)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351,293.82c-2.67,0-4.71-.58-6.11-1.76a5.17,5.17,0,0,1-2.2-3.52l-.1-1.66V256.19q0-7.71-4-9.87a11.85,11.85,0,0,0-5.09-1,15.6,15.6,0,0,0-11.24,4.93q-5,4.93-5,8.85v34.69h-6.84V245h6.84V256.1a19.71,19.71,0,0,1,6.16-7.87,15.27,15.27,0,0,1,9.87-3.67,30.83,30.83,0,0,1,8.74,1,10.15,10.15,0,0,1,4.94,2.88,12.07,12.07,0,0,1,2.44,7.82v30.59a7.2,7.2,0,0,0,1.13,4.35,3.43,3.43,0,0,0,2.29,1.62L354,293h3v.78Z",
    transform: "translate(-102.74 -218.05)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.73,282.58q0,7.73,4.1,9.87a11,11,0,0,0,5,1,15.36,15.36,0,0,0,11-4.69Q393.66,284,394,280V245h6.84v41.93a7.2,7.2,0,0,0,1.13,4.35,3.41,3.41,0,0,0,2.29,1.62l1.08.19h3v.78h-6c-2.68,0-4.71-.58-6.11-1.76a5.17,5.17,0,0,1-2.2-3.52l-.1-1.66v-4.2a20.72,20.72,0,0,1-6.25,7.87,15.25,15.25,0,0,1-9.83,3.66,30.76,30.76,0,0,1-8.7-1,9.5,9.5,0,0,1-4.83-2.89,11.7,11.7,0,0,1-2.54-7.81V245h6.84Z",
    transform: "translate(-102.74 -218.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrmenuLogoBlue);
export default __webpack_public_path__ + "static/media/qrmenu-logo-blue.7c2ee43a9e9781e8d14d300d58a3db93.svg";
export { ForwardRef as ReactComponent };